module.exports = __webpack_public_path__ + "static/media/gallery-20.f7f0f8b8.jpg";